import { render, staticRenderFns } from "./dropdown-menu-item.vue?vue&type=template&id=48ce3fcc"
import script from "./dropdown-menu-item.vue?vue&type=script&lang=js"
export * from "./dropdown-menu-item.vue?vue&type=script&lang=js"
import style0 from "./dropdown-menu-item.vue?vue&type=style&index=0&id=48ce3fcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports